module.exports = __webpack_public_path__ + "static/media/crown.754ef938.png";